import { TLEditorSnapshot } from "tldraw";

import { FeedVersion } from "@/lib/types";

export function getSnapshot(
  feedVersion: FeedVersion,
): TLEditorSnapshot | undefined {
  if (
    feedVersion.metadata?.snapshot &&
    "document" in feedVersion.metadata.snapshot
  ) {
    return feedVersion.metadata.snapshot;
  }

  // we no longer store the snapshot as the entire metadata but dont represent that in types
  if (feedVersion.metadata && "document" in feedVersion.metadata) {
    return feedVersion.metadata as TLEditorSnapshot;
  }

  return undefined;
}
